import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ContactHero } from '../components/contact/ContactHero';
import { LocationContactSelector } from '../components/contact/LocationContactSelector';
export function ContactPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-856">
      <Header data-id="element-857" />

      <main className="pt-20" data-id="element-858">
        <ContactHero data-id="element-859" />
        <LocationContactSelector data-id="element-860" />
      </main>

      <Footer data-id="element-861" />
    </div>;
}